module.exports = __webpack_public_path__ + "img/13.f1f67deb.png";